import Vue from 'www/vue_components'
import I18NextVue from 'i18next-vue'
import vuetify from 'www/modules/vuetify-plugin-without-reset-scss'
import { initI18n } from 'www/utils'
import AwardWinner from 'www/vue_components/common/AwardWinner/AwardWinner.vue'
import 'www/vue_components/common/AwardWinner/index.scss'

const init = async () => {
  const { i18next } = await initI18n({ bundle: 'vue_components/common/AwardWinner' })

  Vue.use(I18NextVue, { i18next })

  // @ts-ignore
  const elements = [...document.querySelectorAll('.vue-award-winner')]

  elements.forEach(el => {
    new Vue({
      el,
      vuetify,
      components: {
        AwardWinner,
      },
    })
  })
}

init()

try {
  const target = document.querySelector('[data-cards-list-container]')

  if (target) {
    new MutationObserver(records => {
      try {
        const [record] = records
        const { addedNodes, removedNodes } = record

        if (addedNodes.length && removedNodes.length) {
          init()
        }
      } catch { /* Empty */ }
    }).observe(target, { childList: true })
  }
} catch { /* Empty */ }
